import {
    GET_REGISTRATIONS_FAIL,
    GET_REGISTRATIONS_SUCCESS,
    ADD_REGISTRATION_SUCCESS,
    ADD_REGISTRATION_FAIL,
    UPDATE_REGISTRATION_SUCCESS,
    UPDATE_REGISTRATION_FAIL,
    DELETE_REGISTRATION_SUCCESS,
    DELETE_REGISTRATION_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    registrations: [],
    error: null,
    loading: true,
    success: false,
};

const registrationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des registrations
        case GET_REGISTRATIONS_SUCCESS:
            return {
                ...state,
                registrations: action.payload.registrations, // tableau d'objets registration
                loading: false,
                error: null,
                success: true
            };

        case GET_REGISTRATIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                success: false
            };

        // Ajout d'une registratione
        case ADD_REGISTRATION_SUCCESS:
            return {
                ...state,
                registrations: [action.payload, ...state.registrations], // ajoute au début du tableau
                error: null,
                success: true
            };

        case ADD_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload,
                success: false
            };

        // Mise à jour d'une registratione
        case UPDATE_REGISTRATION_SUCCESS:
            return {
                ...state,
                registrations: state.registrations.map(registration =>
                    registration.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet registration
                        : registration
                ),
                error: null,
                success: true
            };

        case UPDATE_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload,
                success: false
            };

        // Suppression d'une registratione
        case DELETE_REGISTRATION_SUCCESS:
            return {
                ...state,
                registrations: state.registrations.filter(
                    registration => registration.id !== action.payload
                ),
                error: null,
                success: true
            };


        case DELETE_REGISTRATION_FAIL:
            return {
                ...state,
                error: action.payload,
                success: false
            };

        default:
            return state;
    }
};

export default registrationReducer;
